import React from "react";
import classNames from "classnames";
import { Card, Spinner } from "../../../shared";

const TemplatePicker = ({
  templates = [],
  activeTemplateKey,
  loading,
  onSelectTemplate,
}) => {
  return (
    <Card className="rounded-lg">
      <div className="mb-3 flex items-center justify-between">
        <div>
          <div className="text-xs md:text-sm uppercase text-gray-500 font-bold">
            System Templates
          </div>
          <p className="text-sm text-gray-500">
            Preview template dashboards before custom dashboard saving is enabled.
          </p>
        </div>
        {loading && <Spinner size="sm" />}
      </div>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
        {templates.map((template) => (
          <button
            key={template.templateKey}
            type="button"
            onClick={() => onSelectTemplate(template)}
            className={classNames(
              "rounded-lg border p-3 text-left transition hover:border-primary-400 hover:bg-primary-50",
              {
                "border-primary-500 bg-primary-50":
                  activeTemplateKey === template.templateKey,
                "border-gray-200 bg-white":
                  activeTemplateKey !== template.templateKey,
              }
            )}
          >
            <div className="font-semibold text-gray-800">{template.name}</div>
            <div className="mt-1 text-xs text-gray-500">
              {template.description}
            </div>
          </button>
        ))}
      </div>
    </Card>
  );
};

export default TemplatePicker;
